module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/economics-disabled-normal-50.447ef69f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/economics-disabled-normal-50.png
// module id = 3434
// module chunks = 11